import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            /**
             * Data is considered fresh for 2 minutes – no refetch will happen
             * while data is within this window (e.g. tab switches, screen focus).
             */
            staleTime: 2 * 60 * 1000,

            /**
             * Keep unused query data in the cache for 5 minutes before garbage
             * collection so navigating back to a screen is instant.
             */
            gcTime: 5 * 60 * 1000,

            /**
             * Do NOT refetch just because the window / app regains focus.
             * Real-time updates are handled via WebSockets; manual pull-to-refresh
             * is available for everything else.
             */
            refetchOnWindowFocus: false,

            /**
             * Auto-retry once on transient network failures, but no more.
             */
            retry: 1,
        },
        mutations: {
            retry: 0,
        },
    },
});
